export default __webpack_public_path__ + "static/media/thunder.ee6aeee3.svg";